<template>
    <!--<div>这是资料详情 - {{dataId}} - {{testPara}}</div>-->
    <div :class="[{iosDataInformation: ios, androidDataInformation: android}]">
        <div :class="[{iosBigTitle: ios, iosBigTitle1: ios, androidBigTitle: android, androidBigTitle1: android}]">
            {{this.dataName}}
        </div>

        <div :class="[{iosContentText: ios, iosContentText1: ios, androidContentText: android, androidContentText1: android}]">
            {{dataInfoObject && dataInfoObject.dataDescription}}
        </div>

        <div :class="[{iosBigTitle: ios, iosBigTitle2: ios, androidBigTitle: android, androidBigTitle2: android}]">
            {{teacherInfoTitle}}
        </div>

        <div :class="[{iosContentText: ios, iosContentText2: ios, androidContentText: android, androidContentText2: android}]">
            {{dataInfoObject && dataInfoObject.teacherInfo}}
        </div>
    </div>

</template>

<script>




export default {
  name: 'DataInfo',
  props: {
    dataId: String,
    testPara: String,

  },

  data: function () {
    return {
      dataInfoObject: Object,
      ios: !this.$cjxfIsAndroid,
      android: this.$cjxfIsAndroid,
      // ios: true,
      // android: false,
    }
  },
  computed: {
    dataName: function () {
      switch (this.dataInfoObject && this.dataInfoObject.dataType) {
        case 1:
          return '音檔簡介';
        case 2:
          return '書籍簡介';
        case 3:
          return '影片簡介';
        default:
          return '';
      }
    },

    teacherInfoTitle: function () {
      return this.dataName.length > 0 ? '講師介紹' : '';
    }

  },

  created: async function () {
    // console.log('这是资料详情'); datainfo/145   datainfo/208
    const response = await this.$axios.get('/data/getDataInfo',{
      params: {
        dataId: this.dataId
      }
    });
      this.dataInfoObject = response.data.data;
  }
}
</script>

<style scoped lang="scss">

    $marginLeft: 20pt;

    .iosDataInformation{
        color: #262626;
        background-color: white;
    }
    .iosBigTitle{
        font-weight: bold;
        font-size: 20px;
        margin: 0 $marginLeft;
    }
    .iosContentText{
        /*font-weight: bold;*/
        font-size: 17px;
        margin: 0 $marginLeft;
        text-align: justify;
    }

    .iosBigTitle1{
        margin-top: 24pt;
    }
    .iosBigTitle2{
        margin-top: 24pt;
    }
    .iosContentText1{
        margin-top: 16pt;
    }
    .iosContentText2{
        margin-top: 16pt;
        margin-bottom: 39pt;
    }
    /*-------android的css类-------*/
    .androidDataInformation{
        color: #000000;
        background-color: white;
    }
    .androidBigTitle{
        font-weight: bold;
        font-size: 20px;
        margin: 0 $marginLeft;
    }
    .androidContentText{
        /*font-weight: bold;*/
        font-size: 16px;
        margin: 0 $marginLeft;
        text-align: justify;
    }

    .androidBigTitle1{
        margin-top: 24pt;
    }
    .androidBigTitle2{
        margin-top: 24pt;
    }
    .androidContentText1{
        margin-top: 16pt;
    }
    .androidContentText2{
        margin-top: 16pt;
        margin-bottom: 39pt;
    }

</style>